<template>
  <div class="md-toolbar-row">
    <div class="md-toolbar-section-start">
      <md-button
        class="md-icon-button topLeftMenu"
        @click="$emit('toggle-menu')"
      >
        <md-icon>menu</md-icon>
      </md-button>
      <div class="md-title-div">
        <img class="md-title" :src="logoSrc" :alt="logoAlt" @click="goToRoot" />
      </div>
    </div>

    <div class="md-toolbar-section-end">
      <label
        v-if="!hideAccount"
        class="account-label"
        style="white-space: nowrap"
        >{{ C('account') }}:</label
      >
      <md-field v-if="!hideAccount" class="account-field">
        <md-select
          class="md-select-div"
          md-class="account-select-box"
          style="max-height: 90vh"
          v-model="curAccountId"
          @md-selected="setUserSetting('lastAccount', curAccountId)"
          ref="accountSelect"
        >
          <div class="search-div" v-if="accountSearchEnabled">
            <search-field v-model="search" :fields="searchFields" />
          </div>
          <div class="search-space-div" v-if="accountSearchEnabled"></div>
          <div class="pin-div" v-if="accountPinEnabled">
            <div
              v-for="account in setAccountName(userSetting.pinAccounts)"
              :key="account.id"
            >
              <md-option :value="account.id" class="option-div">
                {{
                  account.name +
                  ($config.topNavigation.showAccountId
                    ? ` (${account.id})`
                    : '')
                }}
                <div class="pin-button">
                  <div class="pin-space">
                    <md-button
                      @click.stop="setPin(account, false)"
                      class="md-primary md-icon-button md-dense pin-button"
                    >
                      <md-icon class="pin">push_pin</md-icon>
                    </md-button>
                  </div>
                </div>
              </md-option>
            </div>
          </div>
          <div>
            <div
              v-if="$config.feature.reseller && userInfo.type === 'megazone'"
            >
              <md-optgroup
                v-for="category in accountCategories"
                :key="category.type"
                :label="category.type"
              >
                <md-option
                  v-for="account in categoryFilters(category)"
                  :key="account.id"
                  :value="account.id"
                  class="option-div"
                  >{{
                    account.name +
                    ($config.topNavigation.showAccountId
                      ? ` (${account.id})`
                      : '')
                  }}
                  <div class="pin-button" v-if="accountPinEnabled">
                    <div class="pin-space">
                      <md-button
                        v-if="account.active"
                        @click.stop="setPin(account, false)"
                        class="md-primary md-icon-button md-dense pin-button"
                      >
                        <md-icon class="pin">push_pin</md-icon>
                      </md-button>
                      <md-button
                        v-if="!account.active"
                        @click.stop="setPin(account, true)"
                        class="md-icon-button md-dense pin-button"
                      >
                        <md-icon class="pin">push_pin</md-icon>
                      </md-button>
                    </div>
                  </div>
                </md-option>
              </md-optgroup>
            </div>
            <div v-for="account in accountFiltered" :key="account.id" v-else>
              <md-option :value="account.id" class="option-div">
                {{
                  account.name +
                  ($config.topNavigation.showAccountId
                    ? ` (${account.id})`
                    : '')
                }}
                <div class="pin-button" v-if="accountPinEnabled">
                  <div class="pin-space">
                    <md-button
                      v-if="account.active"
                      @click.stop="setPin(account, false)"
                      class="md-primary md-icon-button md-dense pin-button"
                    >
                      <md-icon class="pin">push_pin</md-icon>
                    </md-button>
                    <md-button
                      v-if="!account.active"
                      @click.stop="setPin(account, true)"
                      class="md-icon-button md-dense pin-button"
                    >
                      <md-icon class="pin">push_pin</md-icon>
                    </md-button>
                  </div>
                </div>
              </md-option>
            </div>
          </div>
        </md-select>
      </md-field>

      <md-menu md-align-trigger>
        <md-avatar md-menu-trigger>
          <md-ripple>
            <img v-if="userInfo.picture" :src="userInfo.picture" />
            <fa-icon v-if="!userInfo.picture" icon="user-circle" />
          </md-ripple>
          <md-tooltip>{{ userInfo.name }} ({{ userInfo.email }})</md-tooltip>
        </md-avatar>
        <md-menu-content>
          <md-menu-item to="/personal/profile">
            <fa-icon icon="user" />
            <label>{{ L('profile') }}</label>
          </md-menu-item>
          <md-menu-item @click="reload">
            <fa-icon icon="sync-alt" />
            <label>{{ L('reload') }}</label>
          </md-menu-item>
          <md-menu-item @click="logout">
            <fa-icon icon="sign-out-alt" />
            <label>{{ L('logout') }}</label>
          </md-menu-item>
          <md-menu-item @click="openMzAccount">
            <fa-icon icon="arrow-circle-right" />
            <label>{{ L('mzAccount') }}</label>
          </md-menu-item>
        </md-menu-content>
      </md-menu>

      <md-menu md-align-trigger>
        <md-avatar md-menu-trigger>
          <md-ripple>
            <md-icon>settings</md-icon>
          </md-ripple>
        </md-avatar>
        <md-menu-content class="setting">
          <template
            v-if="this.userInfo.admin && $config.feature.globalCorporation"
          >
            <md-subheader>
              {{ L('corporateCategory') }}
            </md-subheader>
            <md-menu-item
              @click="setUserSetting('corporation', null)"
              :class="{ 'md-primary': userSetting.corporation === null }"
              >{{ L('all') }}</md-menu-item
            >
            <md-menu-item
              v-for="corporation in corporations"
              :key="corporation.value"
              @click="setUserSetting('corporation', corporation.value)"
              :class="{
                'md-primary': userSetting.corporation === corporation.value,
              }"
              >{{ L(corporation.name) }}</md-menu-item
            >
            <md-divider></md-divider>
          </template>
          <md-subheader>
            {{ L('language') }}
          </md-subheader>
          <md-menu-item
            v-for="language in languages"
            :key="language.value"
            @click="setUserSetting('language', language.value)"
            :class="{ 'md-primary': $i18n.locale === language.value }"
            >{{ L(language.value) }}</md-menu-item
          >
          <md-divider></md-divider>
          <md-subheader>
            {{ L('currency') }}
          </md-subheader>
          <md-menu-item
            v-for="currency in currencies"
            :key="currency.value"
            @click="setUserSetting('currency', currency.value)"
            :class="{ 'md-primary': displayCurrency === currency.value }"
            >{{ currency.value }}</md-menu-item
          >
          <md-divider></md-divider>
          <md-subheader>
            {{ L('appearance') }}
          </md-subheader>
          <md-menu-item
            v-for="appearance in appearances"
            :key="appearance"
            :class="{ 'md-primary': userSetting.appearance === appearance }"
            @click="setUserSetting('appearance', appearance)"
            >{{ L(appearance) }}</md-menu-item
          >
        </md-menu-content>
      </md-menu>
    </div>

    <md-dialog :md-active.sync="dialog.pinMax" class="dialog">
      <md-dialog-content>
        {{ L('pin_max') }}
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click.stop="dialog.pinMax = false">{{
          L('ok')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="dialog.pinExist" class="dialog">
      <md-dialog-content>
        {{ L('pin_exist') }}
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click.stop="dialog.pinExist = false">{{
          L('ok')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api'
import SearchField from '@/views/layout/SearchField'
import { propFilter } from '@/lib/helper'
import hashes from '@/assets/data/hash.json'
import config from '@/config'
import { currencies, languages, corporations } from '@/lib/code'

let fakeEl = null
function textWidth(inputEl) {
  if (!fakeEl) {
    fakeEl = $('<span>').hide().appendTo(document.body)
  }
  const removePinText = $(inputEl)
    .val()
    .replace(/push_pin/g, '')
    .trim()
  fakeEl.text(removePinText).css('font', $(inputEl).css('font'))
  return fakeEl.width()
}

const mediaQueryList = window.matchMedia('(prefers-color-scheme: Dark)')

export default {
  components: { SearchField },
  props: {
    hideAccount: Boolean,
  },

  data: () => ({
    dialog: {
      pinMax: false,
      pinExist: false,
    },
    langKey: 'menu',
    curAccountId: null,
    search: '',
    searchFields: ['name'],
    userSetting: {
      appearance: 'auto',
      currency: config.currencies.default,
      language: config.languages.default,
      lastAccount: '',
      pinAccounts: [],
      corporation: null,
    },
    appearances: ['light', 'dark', 'auto'],
    languages,
    currencies,
    corporations,
    filteredAccountsByCorporation: [],
  }),

  mounted() {
    mediaQueryList.addEventListener('change', this.setUIAppearance)
  },

  created() {
    this.load()
  },

  updated() {
    this.$nextTick(() => {
      this.adjustAccountSelectLength()
    })
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      displayCurrency: (state) => state.displayCurrency,
    }),

    logoSrc() {
      const logoPath = `${this.$config.logo.dir}/${this.$config.logo.filename}`
      return hashes[logoPath] ? `${logoPath}?${hashes[logoPath]}` : logoPath
    },

    logoAlt() {
      return this.$config.logo.alt
    },

    accountCategories() {
      const array = []

      if (this.$config.feature.reseller && this.userInfo.type === 'megazone') {
        const accounts = this.filteredAccountsByCorporation.filter(
          (account) => account.reseller_seq === 0
        )
        const resellers = this.filteredAccountsByCorporation.filter(
          (account) => account.reseller_seq !== 0
        )

        const pinAccounts = this.accountPinEnabled
          ? this.addActive(accounts)
          : accounts
        const pinResellers = this.accountPinEnabled
          ? this.addActive(resellers)
          : resellers

        array.push({ type: 'partner', list: pinAccounts })
        array.push({ type: 'reseller partner', list: pinResellers })
      } else {
        const pinAccounts = this.accountPinEnabled
          ? this.addActive(this.filteredAccountsByCorporation)
          : this.filteredAccountsByCorporation
        array.push({ type: 'partner', list: pinAccounts })
      }

      return array
    },

    accountFiltered() {
      const accounts = propFilter(
        this.search,
        this.filteredAccountsByCorporation,
        this.searchFields
      ).sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))

      const pinAccounts = this.accountPinEnabled
        ? this.addActive(accounts)
        : accounts
      return pinAccounts
    },

    accountSearchEnabled() {
      return (
        this.userInfo.resource.accounts.length >=
        this.$config.topNavigation.minAccountForSearch
      )
    },

    accountPinEnabled() {
      return (
        this.userInfo.resource.accounts.length >=
        this.$config.topNavigation.minAccountForPin
      )
    },
  },

  methods: {
    logout() {
      api.session.logout()
      this.closeSocket()
    },

    openMzAccount() {
      window.open(this.$config.megazoneAccount.url)
    },

    async load(reload) {
      if (this.$config.topNavigation.showAccountId) {
        this.searchFields = ['name', 'id']
      }

      const session = await api.session.info({ reload })
      this.$store.commit('userInfo', session)
      const userSetting = await this.getUserSetting(session.seq)
      if (userSetting) {
        this.userSetting = {
          language: userSetting.data.language || this.userSetting.language,
          appearance:
            userSetting.data.appearance || this.userSetting.appearance,
          currency: userSetting.data.currency || this.userSetting.currency,
          lastAccount:
            userSetting.data.lastAccount || this.userSetting.lastAccount,
          pinAccounts:
            userSetting.data.pinAccounts || this.userSetting.pinAccounts,
          corporation:
            userSetting.data.corporation || this.userSetting.corporation,
        }
      }

      this.userSetting.pinAccounts = this.userSetting.pinAccounts.filter((id) =>
        session.resource.accounts.some((a) => a.id === id)
      )

      if (session.resource.accounts.length <= 1) {
        config.billing.consolidated.enabled = false
      }

      if (!reload) {
        this.setUILanguage()
        this.setUICurrency()
        this.setUIAppearance()
        this.setUILastAccount()
        this.setUICorporation()
        this.createSocket(session.seq)
      }

      if (this.$config.currencies.cny.enabled) {
        const { corporation } = await api.account.getAccountCorporation(
          this.curAccountId
        )
        const isChina = corporation === 'china'

        if (isChina) {
          if (!userSetting || !userSetting.data.currency) {
            this.setUserSetting('currency', 'CNY')
          }
          if (!userSetting || !userSetting.data.language) {
            this.setUserSetting('language', 'en')
          }
        }
      }
    },

    reload() {
      this.load(true)
    },

    getUserSetting(userSeq) {
      return api.userSetting.get(userSeq, 'global.user', 'custom')
    },

    async setUserSetting(type, value) {
      this.userSetting[type] = value
      switch (type) {
        case 'language':
          this.setUILanguage()
          break
        case 'currency':
          this.setUICurrency()
          break
        case 'appearance':
          this.setUIAppearance()
          break
        case 'lastAccount':
          this.setUILastAccount()
          break
        case 'corporation':
          this.setUICorporation()
          break
        default:
          break
      }

      await api.userSetting.modify(
        this.userInfo.seq,
        'global.user',
        'custom',
        this.userSetting
      )

      const {
        currency,
        applyDiscount,
        enabled,
        language,
        appearance,
        corporation,
      } = this.userSetting

      const settingInfo = {
        currency,
        applyDiscount,
        enabled,
        language,
        appearance,
        corporation,
      }

      localStorage.setItem('settingInfo', JSON.stringify(settingInfo))
    },

    setUILanguage() {
      this.$i18n.locale = this.userSetting.language

      this.$material.locale = {
        ...this.$material.locale,
        ...this.$i18n.messages[this.userSetting.language].material,
      }
    },

    setUICurrency() {
      this.$store.commit('displayCurrency', this.userSetting.currency)
    },

    setUIAppearance() {
      let { appearance } = this.userSetting
      if (appearance === 'auto')
        appearance = mediaQueryList.matches ? 'dark' : 'light'

      this.$material.theming.theme = `${this.$config.platform.id}-${appearance}`
      document.documentElement.style.setProperty(
        '--theme-color',
        `var(--md-theme-${this.$config.platform.id}-${appearance}-primary)`
      )
      document.getElementById('favicon').href = `/img/fav-${appearance}.png`

      return appearance === 'dark'
        ? document.body.classList.add('dark')
        : document.body.classList.remove('dark')
    },

    async setUICorporation() {
      this.$store.commit('corporation', this.userSetting.corporation)

      let { accounts } = this.userInfo.resource
      if (
        this.userInfo.admin &&
        this.corporations &&
        this.userSetting.corporation
      ) {
        accounts = accounts.filter(
          (a) => a.corporation === this.userSetting.corporation
        )
      }
      this.filteredAccountsByCorporation = accounts

      this.curAccountId = null
      if (this.filteredAccountsByCorporation.length > 0) {
        const accountId = this.filteredAccountsByCorporation[0].id
        this.curAccountId = accountId
      }
      if (
        this.filteredAccountsByCorporation.find(
          (a) => a.id === this.userSetting.lastAccount
        )
      ) {
        this.curAccountId = this.userSetting.lastAccount
      }
    },

    goToRoot() {
      this.$router.push('/')
    },

    setUILastAccount() {
      if (!this.userSetting.lastAccount) {
        return
      }

      this.$store.commit(
        'curAccount',
        this.userInfo.resource.accounts.find(
          (a) => a.id === this.userSetting.lastAccount
        )
      )

      this.search = ''
    },

    adjustAccountSelectLength() {
      if (this.$refs.accountSelect) {
        const inputEl = $(this.$refs.accountSelect.$el)
          .children('input')
          .first()
        const width = textWidth(inputEl)
        $(inputEl).css({ width })
      }
    },

    categoryFilters(category) {
      return propFilter(this.search, category.list, this.searchFields).sort(
        (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
      )
    },

    setPin(account, type) {
      if (!this.accountPinEnabled) return

      const { pinAccounts } = this.userSetting

      if (type === true) {
        if (this.userSetting.pinAccounts.length >= 5) {
          this.dialog.pinMax = true
          return
        }

        if (this.userSetting.pinAccounts.find((id) => id === account.id)) {
          this.dialog.pinExist = true
          return
        }

        pinAccounts.push(account.id)
      } else {
        pinAccounts.splice(
          pinAccounts.findIndex((id) => id === account.id),
          1
        )
      }

      this.setUserSetting('pinAccounts', pinAccounts)
    },

    addActive(accounts) {
      return accounts.map((e) => {
        const active = this.userSetting.pinAccounts.some((id) => id === e.id)
        return { ...e, active }
      })
    },

    setAccountName(accounts) {
      return accounts
        .map((id) => ({
          id,
          name: this.userInfo.resource.accounts.find((e) => e.id === id).name,
        }))
        .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
    },
  },
}
</script>

<style lang="scss" scoped>
.md-toolbar-row {
  min-height: 48px;
}

.md-toolbar-section-start .md-title {
  margin-left: 10px;
}

.md-toolbar-section-end {
  flex: 0;
}

.account-btn {
  text-transform: none;
}

.account-item {
  margin-top: -4px;
  margin-bottom: -4px;
}

.md-menu-item .md-icon {
  margin-left: 0px;
  margin-right: 10px;
}

.topLeftMenu {
  display: none;
}

img.md-title {
  cursor: pointer;
  width: 100%;
  filter: invert(1) brightness(1.2);
}

.md-title-div {
  width: 155px;
}

@media only screen and (max-width: 800px) {
  .md-toolbar-row {
    position: relative;
    left: -1.9vh;
  }

  .account-label {
    display: none;
  }

  .account-btn {
    font-size: 12px;
  }

  .topLeftMenu {
    display: block;
  }

  .md-toolbar-section-start .md-title {
    margin-left: 0;
  }

  .md-title-div {
    width: 100px;
    line-height: 0px;
  }
}

.md-select-div ::v-deep i {
  position: relative;
  left: -0.7vh;
}

.account-field {
  min-height: 31px;
  position: relative;
  left: 8px;
  top: -1px;

  // INPUT 텍스트 색깔 및 모양 조정
  &::v-deep input {
    -webkit-text-fill-color: white !important;
    font-size: 14px !important;
    font-weight: 500;
  }

  // 밑줄 제거
  &::after {
    height: 0px;
  }
}

.search-space-div {
  height: 40px;
}

.pin-div {
  position: sticky;
  top: 40px;
  z-index: 20;
}

.option-div {
  height: 30px;
}

.pin-button {
  display: flex;
  flex-direction: row-reverse;
}

.pin-space {
  width: 50px;
  display: flex;
  flex-direction: row-reverse;
}

.pin {
  font-size: 15px !important;
  position: relative;
  right: 4px;
}

.dialog {
  z-index: 50;
}
</style>

<style lang="scss">
.account-select-box {
  top: 5.5vh !important;
  max-height: 65vh;

  & .md-list {
    padding: 0;
  }
}

.account-select-box .md-list-item-content {
  min-height: 3.5vh;
}

.md-list-item-text {
  flex-direction: row !important;
  align-items: center;
}

.setting {
  .md-subheader {
    min-height: 30px !important;
    font-size: 13px !important;
  }

  .md-icon {
    margin: 3px !important;
  }

  .md-list-item-content {
    min-height: 30px !important;
    padding: 4px 28px !important;
  }
}
</style>
